module.exports = __webpack_public_path__ + "img/check.60a4763a.svg";